module.exports = __webpack_public_path__ + "assets/img/netBank.864c9b1e.webp";